import { CalendarTemplateInterface } from '@/commerce/Common/interfaces/calendar-template.interface'
import { CalendarAssignmentInterface } from '@/commerce/Common/interfaces/calendar-assignment.interface'
import Axios, { AxiosInstance } from 'axios'
import { apiConstants, ApiConstantsInterface } from '../constants/api.constants'

interface CalendarTemplateServiceInterface {
  getAssignments(): Promise<CalendarAssignmentInterface[]>
  getCalendarTemplates(): Promise<CalendarTemplateInterface[]>
  getCalendarTemplate(id: number): Promise<CalendarTemplateInterface>
  createCalendarTemplate(calendarTemplate: CalendarTemplateInterface) 
  updateCalendarTemplate(calendarTemplate: CalendarTemplateInterface)
  deleteCalendarTemplate(calendarTemplate: CalendarTemplateInterface)
}

class CalendarTemplateService implements CalendarTemplateServiceInterface {
  protected axios: AxiosInstance

  protected config: ApiConstantsInterface

  constructor(config: ApiConstantsInterface) {
    this.config = config
    this.axios = Axios.create({
      baseURL: config.baseUrl,
    })
  }

  async getCalendarTemplates(): Promise<CalendarTemplateInterface[]> {
    const response = await this.axios.get(`${this.config.calendarTemplates}`)
    return response.data
  }

  async getCalendarTemplate(id: number): Promise<CalendarTemplateInterface> {
    const response = await this.axios.get(`${this.config.calendarTemplates}/${id}`)
    return response.data
  }

  async createCalendarTemplate(calendarTemplate: CalendarTemplateInterface) {
    const response = await this.axios.post(`${this.config.calendarTemplates}`, calendarTemplate)
    return response.data
  }

  async updateCalendarTemplate(calendarTemplate: CalendarTemplateInterface) {
    const response = await this.axios.put(`${this.config.calendarTemplates}/${calendarTemplate.Id}`, calendarTemplate)
    return response.data
  }

  async deleteCalendarTemplate(calendarTemplate: CalendarTemplateInterface) {
    const response = await this.axios.delete(`${this.config.calendarTemplates}/${calendarTemplate.Id}`)
    return response.data
  }

  async getAssignments(): Promise<CalendarAssignmentInterface[]> {
    const response = await this.axios.get(`${this.config.calendarTemplates}/assignments`)
    return response.data
  }
}

const calendarTemplateService = new CalendarTemplateService(apiConstants)
export { calendarTemplateService }
